const state = {
	option: 'featured',
	mapLegend: document.querySelector('#ski-resorts'),
	map: document.querySelector('#map-ski-resorts'),
}

const toggleLocations = () => {
	const locationOptions = document.querySelector('.location__options');
	if (locationOptions) {
		locationOptions.addEventListener('click', (evt) => {
			if (evt.target.dataset.value && !evt.target.classList.contains('dropdown__item--active')) {
				const optionsToggle = locationOptions.previousElementSibling;
				
				locationOptions.classList.remove('dropdown__list--active');
				optionsToggle.classList.remove('dropdown__toggle--active');
				
				optionsToggle.textContent = evt.target.textContent;
				locationOptions.querySelector('.dropdown__item--active').classList.remove('dropdown__item--active');
				evt.target.classList.add('dropdown__item--active');
				
				state.mapLegend.classList.remove('location__map-legend--active');
				state.map.classList.remove('location__map--active');
				
				state.option = evt.target.dataset.value;
				state.mapLegend = document.querySelector(`#${state.option}`);
				state.map = document.querySelector(`#map-${state.option}`);
				
				state.mapLegend.classList.add('location__map-legend--active');
				state.map.classList.add('location__map--active');
				
			}
		});
	}
}

export default toggleLocations;
